import { BaseForm } from '@vivaldis/antd-ui'
import { useTranslation } from 'react-i18next'
import { Grid } from '../../../../../Grid'
import { WORK_CLOTHES_AND_PROTECTIVE_EQUIPMENT_ITEMS } from '../../../../constants/wpsFormSteps'
import { WPSItemCheckbox } from '../../../WPSItemCheckbox'

export const Step2 = () => {
  const [t] = useTranslation('web_ui')

  return (
    <BaseForm.Item
      label={t('work_post_sheet_form.group_1.label')}
      tooltip={t('work_post_sheet_form.group_1.hint')}
    >
      <Grid columns={1} gap={0} columnGap={16} marginTop={6}>
        {WORK_CLOTHES_AND_PROTECTIVE_EQUIPMENT_ITEMS.map(name => (
          <WPSItemCheckbox key={name} name={name} />
        ))}
      </Grid>
    </BaseForm.Item>
  )
}
